import { observable } from 'mobx';
import { PostCompositionTypeValues } from '@sprinklr/stories/widget/types';
import { PostsWidgetOptions, PostsWidgetOptionsImpl } from '../options';

export class PostsWidgetCollageOptionsImpl extends PostsWidgetOptionsImpl
    implements PostsWidgetOptions {
    @observable postCompositionType: PostCompositionTypeValues = 'a';
}
